var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container", attrs: { id: "goods-edit" } }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("矩阵管理")]),
            ]),
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { path: "/goodsList" } } },
              [_c("div", { staticClass: "div1" }, [_vm._v("保证金查看")])]
            ),
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { path: "/goodsList" } } },
              [_c("div", { staticClass: "div2" }, [_vm._v("冻结金额")])]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "content" }, [
      _c("h2", [_vm._v("冻结金额")]),
      _c("h3", [_vm._v("数据筛选")]),
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              attrs: { inline: true, model: _vm.searchForm, size: "small" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "订单编号", prop: "brandId" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入订单编号" },
                    model: {
                      value: _vm.searchForm.orderNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "orderNo", $$v)
                      },
                      expression: "searchForm.orderNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品名称", prop: "goodsName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入商品名称", clearable: "" },
                    model: {
                      value: _vm.searchForm.goodsName,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "goodsName", $$v)
                      },
                      expression: "searchForm.goodsName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "类型", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择类型",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.searchForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "type", $$v)
                        },
                        expression: "searchForm.type",
                      },
                    },
                    _vm._l(_vm.types, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择状态",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    _vm._l(_vm.statuss, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "时间", prop: "brandId" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "default-time": ["00:00:00", "23:59:59"],
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.updatedTime,
                      callback: function ($$v) {
                        _vm.updatedTime = $$v
                      },
                      expression: "updatedTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fetchData("search")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.fetchData("reset")
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "content" }, [
      _vm._m(0),
      _c(
        "div",
        { attrs: { id: "base-list" } },
        [
          _c("lb-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
              {
                name: "horizontal-scroll",
                rawName: "v-horizontal-scroll",
                value: "always",
                expression: "'always'",
              },
            ],
            attrs: {
              column: _vm.columns,
              data: _vm.page.list,
              pagination: "",
              total: _vm.page.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50],
              "current-page": _vm.page.currentPage,
              "page-size": _vm.page.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "selection-change": _vm.onMultipleSelection,
              "size-change": _vm.handleSizeChange,
              "p-current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c("h3", [_vm._v("列表数据")]),
      _c("div"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }